<div>
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div>
      <p class="heading m-0">My Scheduler Performance (Last 1 Day)</p>
      <div class="counter-row mt-1" *ngIf="!loading && !errorMessage">
        <span class="counter-pill counter-total">Total: {{ totalCount }}</span>
        <span class="counter-pill counter-running">Running: {{ runningCount }}</span>
        <span class="counter-pill counter-completed">Completed: {{ completedCount }}</span>
        <span class="counter-pill counter-incomplete">Incomplete: {{ incompleteCount }}</span>
        <span class="counter-pill counter-terminated">Terminated: {{ terminatedCount }}</span>
        <span class="counter-pill counter-skipped">Skipped: {{ totalSkippedCount }}</span>
      </div>
    </div>
    <button type="button" class="btn btn-sm btn-outline-primary" (click)="refreshWidget()">Refresh</button>
  </div>

  <div class="widget-subtitle mb-2">
    Showing latest execution result per scheduler for your user.
  </div>

  <div *ngIf="loading" class="no-record">Loading scheduler performance...</div>
  <div *ngIf="!loading && errorMessage" class="error-msg">{{ errorMessage }}</div>

  <div class="table-responsive" *ngIf="!loading && !errorMessage">
    <table class="table table-sm table-striped table-bordered m-0">
      <thead>
        <tr>
          <th>Scheduler Name</th>
          <th style="width: 250px;">Result</th>
          <th style="width: 180px;">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of visibleRows">
          <td>{{ row.schedulerName }}</td>
          <td>
            <div class="result-badges">
              <span class="result-pill pass-pill">Pass: {{ row.passCount }}</span>
              <span class="result-pill fail-pill">Fail: {{ row.failCount }}</span>
              <span class="result-pill skip-pill">Skip: {{ row.skipCount }}</span>
            </div>
          </td>
          <td>
            <button type="button" class="btn btn-outline statusBtn" [ngClass]="getStatusClass(row)">
              {{ row.statusText }}
            </button>
          </td>
        </tr>
        <tr *ngIf="rows.length === 0">
          <td colspan="3" class="no-record">No scheduler execution found in last 1 day.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex justify-content-end mt-2" *ngIf="!loading && canSeeMore">
    <span class="see-more-link" (click)="toggleSeeMore()">
      {{ showAll ? 'See Less...' : 'See More...' }}
    </span>
  </div>
</div>
